<script>
    import Icon from './Icon.svelte';

    let className = '';
    export { className as class };

    export let xs = false;
    export let sm = false;
    export let lg = false;
    export let xl = false;
    export let xxl = false;
    export let xxxl = false;

    export let invert = false;

    export let value = void 0;
    export let checked = false;
    export let group = checked ? [value] : [];
    export let name = '';
    export let disabled = false;

    export let required = false;

    $: group && updateChekbox(group, value);
    $: group && updateGroup(checked, value);

    function updateChekbox(group, value) {
        checked = group.indexOf(value) >= 0;
    }

    function updateGroup(checked, value) {
        const index = group.indexOf(value);
        if (checked) {
            if (index < 0) {
                group.push(value);
                group = group;
            }
        } else {
            if (index >= 0) {
                group.splice(index, 1);
                group = group;
            }
        }
    }
</script>

<label
    class="{className} select-none relative cursor-pointer inline-flex flex-row flex-nowrap items-start gap-2"
>
    <input
        class="opacity-0 absolute top-0 left-0 peer"
        {name}
        type="checkbox"
        {value}
        bind:checked
        on:change
        {required}
        {disabled}
    />
    <i
        class="
        inline-block
        relative
        align-text-bottom
        leading-none
        flex-shrink-0
        {xs
            ? 'h-4 w-4'
            : sm
            ? 'h-5 w-5 mr-1'
            : lg
            ? 'h-9 w-9'
            : xl
            ? 'h-13 w-13'
            : xxl
            ? 'h-17 w-17'
            : xxxl
            ? 'h-25 w-25'
            : 'h-7 w-7'}
        border
        
        rounded
        peer-focus:ring-4
        
        {disabled ? 'opacity-50 cursor-not-allowed' : ''}
        {invert
            ? 'bg-surface-invert-highlight border-border-invert-default text-symbols-invert-default'
            : 'bg-surface-highlight border-border-default text-symbols-default'}

        peer-focus:ring-blue-500

    "
    >
        {#if checked}
            <Icon check class="absolute top-0 left-0 w-full h-full" />
        {/if}
    </i>
    {#if $$slots.default || $$slots.small}
        <span class="inline-block flex-1 leading-7 {disabled ? 'opacity-60' : ''}">
            <slot />
            {#if $$slots.small}
                <small class="block text-base opacity-90"
                    ><slot name="small" /></small
                >
            {/if}
        </span>
    {/if}
</label>
